import type { FileRef } from '@/shared/lib'
import { apiRequest } from './client'

// Байты не идут через API. Канал: presign у бэкенда → прямой PUT в S3 →
// FileRef в тело create-фичи (документы/счета/вложения встреч).

interface UploadUrlResponse {
  upload_url: string
  file: FileRef
}

export async function uploadFile(
  file: File,
  onProgress?: (fraction: number) => void,
): Promise<FileRef> {
  const { upload_url, file: fileRef } = await apiRequest<UploadUrlResponse>({
    method: 'POST',
    url: '/files/upload-url',
    body: {
      file_name: file.name,
      content_type: file.type || undefined,
      size: file.size,
    },
  })
  await putBytes(upload_url, file, onProgress)
  return fileRef
}

// fetch не даёт upload-прогресс в браузере — берём XHR. Presigned-URL абсолютный,
// на другом origin (S3); credentials не шлём.
function putBytes(url: string, file: File, onProgress?: (fraction: number) => void): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', url)
    if (file.type) xhr.setRequestHeader('Content-Type', file.type)
    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable) onProgress?.(e.loaded / e.total)
    })
    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        onProgress?.(1)
        resolve()
      } else {
        reject(new Error(`upload: HTTP ${xhr.status}`))
      }
    })
    xhr.addEventListener('error', () => reject(new Error('upload: network error')))
    xhr.send(file)
  })
}
